import Icon from 'veui/components/Icon'
import { IconAlignRight } from 'dls-icons-vue'

Icon.register('align-right', IconAlignRight)
